import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqList } from '@/mocks/faq';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {t('faq.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqList.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openId === faq.id ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500" />
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <div className="pt-1 border-t border-background-200/70">
                    <p className="text-sm text-foreground-600 leading-relaxed pt-3">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}